import { useStaticQuery, graphql } from "gatsby"
import fromEntries from "fromentries"

function useProducts() {
  const data = useStaticQuery(graphql`
    query AllProductsQuery {
      allSanityProduct {
        nodes {
          name
          ourID
          variants {
            ourID
            name
            cartName
            portionContent
            price
            productContent
            shopifyID
            woocommerceID
            image {
              asset {
                fixed(width: 100) {
                  ...GatsbySanityImageFixed
                }
              }
            }
            subscriptions {
              cartName
              frequencyDays
              name
              ourID
              price
              savingPercentage
              woocommerceID
            }
          }
        }
      }
    }
  `)

  return fromEntries(data.allSanityProduct.nodes.map(product => [product.ourID, product]))
}

export { useProducts }
